import React from 'react';
import bannerImage from '../assets/Asleekbannerfora.png';

const Hero = () => (
  <div className="hero">
    <img src={bannerImage} alt="SP Rao Technologies" className="hero-image" />
    <h1>Empowering SAP ABAP Professionals Since 2007</h1>
  </div>
);

export default Hero;